import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerGroupGeoDiscrete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#4996b2",
      }}
      d="M19 7h-2.2c-.3-1.7-1-3-1.8-3s-1.5 1.2-1.8 3H12v1h1v2h-1v1h1.2c.3 1.7 1 3 1.8 3s1.5-1.2 1.8-3H19v-1h-2V8h2V7zm-4-2.3c.4 0 .8 1 .9 2.3h-1.8c.1-1.3.5-2.3.9-2.3zm0 8.6c-.4 0-.8-1-.9-2.3h1.8c-.1 1.3-.5 2.3-.9 2.3zM16 9v1h-2V8h2v1z"
    />
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M15 4c-1.1 0-2.2.4-3 1v1.4c.7-.9 1.8-1.4 3-1.4 2.2 0 4 1.8 4 4s-1.8 4-4 4c-1.2 0-2.3-.5-3-1.4V13c.8.6 1.9 1 3 1 2.8 0 5-2.2 5-5s-2.2-5-5-5zM7.5 2C5.6 2 4 3.6 4 5.5v7C4 13.9 5.1 15 6.5 15S9 13.9 9 12.5v-6C9 5.7 8.3 5 7.5 5S6 5.7 6 6.5v5h1v-5c0-.3.2-.5.5-.5s.5.2.5.5v6c0 .8-.7 1.5-1.5 1.5S5 13.3 5 12.5v-7C5 4.1 6.1 3 7.5 3S10 4.1 10 5.5v6h1v-6C11 3.6 9.4 2 7.5 2z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerGroupGeoDiscrete);
export default Memo;
